<template>
  <div>
    <StringArray
      class="mb-2"
      object-name="election"
      :attribute-name="attribute"
      :items="items.filter((item: string) => item !== '*')"
      :placeholder="$t('js.backend.election_config.override.statistics__segments.new_segment')"
      :disabled="statisticsSegments"
      v-show="!statisticsSegments"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "@/types";
import StringArray from "../attributes/StringArray.vue";

export default defineComponent({
  name: "StatisticsSegments",
  components: { StringArray },
  props: {
    attribute: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  data() {
    return {
      statisticsSegments: this.items.includes("*"),
    };
  },
});
</script>
